<template lang="html">
    <div class="cell-container">
        <div class="cell-value" @click="btnClickedHandler()" :title="value">{{ value }}</div>
    </div>
</template>
<script>
export default {
    name: 'CenterCellRenderer',
    data() {
        return {

        }
    },
    methods: {
        btnClickedHandler() {
            if (!this.params.clicked) return;

            this.params.clicked(this.params.data);
        }
    },
    computed: {
        value() {
            return this.params.value ?? '-';
        }
    }
}
</script>
<style lang="css">
.cell-value {
    max-width: 80%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
</style>